var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEpicLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 286.566,
    height: 108.347,
    viewBox: "0 0 286.566 108.347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69037",
    "data-name": "Group 69037",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68661",
    "data-name": "Group 68661",
    transform: "translate(120.807 34.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68659",
    "data-name": "Group 68659",
    transform: "translate(39.141 27.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104938",
    "data-name": "Path 104938",
    d: "M552.234,774.361H539.281V762.476h12.75V765.1h-9.279v2.023h8.788v2.483h-8.788v2.048h9.482v2.7Zm0,0",
    transform: "translate(-539.281 -762.455)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104939",
    "data-name": "Path 104939",
    d: "M794.21,774.779H781.46v-11.7h12.55v2.586h-9.133v1.991h8.65V770.1h-8.65v2.016h9.333v2.662Zm0,0",
    transform: "translate(-706.733 -762.873)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104940",
    "data-name": "Path 104940",
    d: "M603.122,774.361h-5.24l-6.9-8.89h-.068v8.89h-3.437V762.476H592.8l6.815,8.9h.068v-8.9h3.437v11.885Zm0,0",
    transform: "translate(-572.606 -762.455)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104941",
    "data-name": "Path 104941",
    d: "M737.719,774.361h-5.24l-6.9-8.89h-.068v8.89h-3.438V762.476H727.4l6.815,8.9h.068v-8.9h3.437v11.885Zm0,0",
    transform: "translate(-665.671 -762.455)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104942",
    "data-name": "Path 104942",
    d: "M654.086,774.471q-1.651,0-2.848-.08a10.569,10.569,0,0,1-2.036-.309,3.854,3.854,0,0,1-1.361-.635,2.692,2.692,0,0,1-.813-1.058,5.317,5.317,0,0,1-.389-1.579,20.727,20.727,0,0,1-.1-2.2v-.347a20.152,20.152,0,0,1,.1-2.214,5.321,5.321,0,0,1,.4-1.587,2.691,2.691,0,0,1,.817-1.054,3.849,3.849,0,0,1,1.361-.626,10.6,10.6,0,0,1,2.035-.3q1.2-.076,2.831-.076h.528q1.374,0,2.4.059a12.079,12.079,0,0,1,1.772.216,4.31,4.31,0,0,1,1.222.428,2.184,2.184,0,0,1,.762.69,2.647,2.647,0,0,1,.389,1,7.471,7.471,0,0,1,.109,1.363v.457h-3.367v-.144a1.635,1.635,0,0,0-.126-.681.923.923,0,0,0-.493-.44,3.475,3.475,0,0,0-1.034-.233q-.665-.067-1.753-.068h-.293q-.988,0-1.686.034a6.243,6.243,0,0,0-1.163.148,1.957,1.957,0,0,0-.736.326,1.26,1.26,0,0,0-.406.575,3.327,3.327,0,0,0-.172.9q-.037.538-.037,1.291v.211q0,.737.037,1.262a3.232,3.232,0,0,0,.172.884,1.259,1.259,0,0,0,.406.572,1.963,1.963,0,0,0,.736.326,6.262,6.262,0,0,0,1.163.148q.7.034,1.686.034h.293q.8,0,1.385-.03a9.28,9.28,0,0,0,.979-.093,2.37,2.37,0,0,0,.636-.177.979.979,0,0,0,.368-.288.956.956,0,0,0,.171-.406,3.149,3.149,0,0,0,.042-.546v-.33h-4.549v-2.294h7.874v2.641a8.773,8.773,0,0,1-.113,1.5,3.134,3.134,0,0,1-.4,1.118,2.389,2.389,0,0,1-.779.779,4.146,4.146,0,0,1-1.244.491,11.223,11.223,0,0,1-1.8.258q-1.052.077-2.45.076Zm0,0",
    transform: "translate(-613.443 -762.408)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104943",
    "data-name": "Path 104943",
    d: "M706.05,774.639h-3.485V762.847h3.485v11.792Zm0,0",
    transform: "translate(-652.182 -762.711)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68660",
    "data-name": "Group 68660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104944",
    "data-name": "Path 104944",
    d: "M424.861,695.175q-2.525,0-4.429-.135a20.631,20.631,0,0,1-3.285-.462,7.794,7.794,0,0,1-2.288-.888,4.463,4.463,0,0,1-1.447-1.4,5.647,5.647,0,0,1-.761-2.007,14.689,14.689,0,0,1-.221-2.716V674.151h6.112v11.43q0,1.059.074,1.82a4.4,4.4,0,0,0,.3,1.3,2.109,2.109,0,0,0,.657.865,3.188,3.188,0,0,0,1.137.515,8.98,8.98,0,0,0,1.742.246q1.033.06,2.466.06h.516q1.433,0,2.466-.067a9.9,9.9,0,0,0,1.742-.246,3.028,3.028,0,0,0,1.137-.515,2.172,2.172,0,0,0,.657-.865,4.337,4.337,0,0,0,.3-1.3q.074-.769.074-1.813v-11.43h6.112v13.414a15.7,15.7,0,0,1-.207,2.708,5.547,5.547,0,0,1-.738,2.015,4.414,4.414,0,0,1-1.432,1.4,7.691,7.691,0,0,1-2.281.888,20.671,20.671,0,0,1-3.3.462q-1.919.135-4.473.135Z",
    transform: "translate(-412.43 -674.135)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104945",
    "data-name": "Path 104945",
    d: "M535.776,694.885h-9.139L514.6,679.337h-.119v15.548h-5.994V674.1h9.287l11.885,15.563h.118V674.1h5.994v20.785Zm0,0",
    transform: "translate(-478.851 -674.1)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104946",
    "data-name": "Path 104946",
    d: "M624.669,684.589q1.58,0,2.517-.1a3.375,3.375,0,0,0,1.425-.4,1.412,1.412,0,0,0,.635-.851,5.694,5.694,0,0,0,.147-1.44v-.358a5.623,5.623,0,0,0-.147-1.425,1.348,1.348,0,0,0-.642-.835,3.608,3.608,0,0,0-1.432-.388q-.938-.1-2.5-.1H617.05v5.894Zm10.881,10.3h-6.038V693.2a14.275,14.275,0,0,0-.074-1.567,3.175,3.175,0,0,0-.31-1.111,1.893,1.893,0,0,0-.664-.731,3.384,3.384,0,0,0-1.13-.425,11.262,11.262,0,0,0-1.727-.2q-1.026-.052-2.444-.052H617.05v5.774H611V674.1h16.122a22.911,22.911,0,0,1,4.178.313,5.979,5.979,0,0,1,2.584,1.052,3.781,3.781,0,0,1,1.307,1.955,10.7,10.7,0,0,1,.362,3.007v.731a10.542,10.542,0,0,1-.192,2.141,4.645,4.645,0,0,1-.62,1.581,3.6,3.6,0,0,1-1.108,1.1,5.241,5.241,0,0,1-1.668.657v.119a8.971,8.971,0,0,1,1.794.455,2.427,2.427,0,0,1,1.1.82,3.313,3.313,0,0,1,.546,1.425,14.066,14.066,0,0,1,.148,2.253v3.179Zm0,0",
    transform: "translate(-549.727 -674.1)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104947",
    "data-name": "Path 104947",
    d: "M726.016,694.885H703.427V674.1h22.235v4.6H709.48v3.536h15.325v4.342H709.48v3.581h16.535v4.73Zm0,0",
    transform: "translate(-613.637 -674.1)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104948",
    "data-name": "Path 104948",
    d: "M799.848,686.864l-4.237-8.341h-.148l-4.208,8.341Zm10.7,8.073h-6.6l-1.9-3.731H789.084l-1.875,3.731h-6.541l11.162-20.785h7.5l11.221,20.785Zm0,0",
    transform: "translate(-667.045 -674.135)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104949",
    "data-name": "Path 104949",
    d: "M904.769,694.936h-20.02V674.151h6.113V690.1h13.907v4.835Zm0,0",
    transform: "translate(-739.01 -674.135)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68662",
    "data-name": "Group 68662",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104950",
    "data-name": "Path 104950",
    d: "M153.506,672.1v0a33.269,33.269,0,0,1-17.959,22.359l-5.5-6.161-9.241,9.284A32.491,32.491,0,0,1,95.07,684a16.661,16.661,0,0,0,3,.464c1.456.027,3.037-.508,3.037-2.956V657.358a3.975,3.975,0,0,0-5-3.979c-4.122.944-7.312,11.228-7.312,11.228a33.089,33.089,0,0,1,11.318-25.058,32.308,32.308,0,0,1,16.6-7.709c-4.5,2.566-7.028,6.749-7.028,10.255,0,5.633,3.4,4.966,4.408,4.135v32.595a5.227,5.227,0,0,0,.67,1.148,4.806,4.806,0,0,0,3.934,2c3.407,0,7.826-3.888,7.826-3.888V651.693a9.124,9.124,0,0,0-4.05-7.038,9.285,9.285,0,0,1,6.649,1.55h0a24.7,24.7,0,0,1,1.731-1.905,32.747,32.747,0,0,1,18.405-9.458h.006s-9.645,7.571-9.645,17.728c0,7.554.2,25.979.2,25.979C143.388,682,148.7,677.017,153.506,672.1Z",
    transform: "translate(-67.846 -610.362)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104951",
    "data-name": "Path 104951",
    d: "M74.643,562.234c-29.675,0-53.731,24.254-53.731,54.173s24.056,54.173,53.731,54.173,53.731-24.254,53.731-54.173-24.056-54.173-53.731-54.173m0,2.384a50.819,50.819,0,0,1,36.321,15.169,52.091,52.091,0,0,1,0,73.241,51.071,51.071,0,0,1-72.643,0,52.091,52.091,0,0,1,0-73.241,50.818,50.818,0,0,1,36.321-15.169",
    transform: "translate(-20.912 -562.234)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicLogo);
export default __webpack_public_path__ + "static/media/Epic_logo.39f64d8afb038aca4e9ee3b8a5f4e7e2.svg";
export { ForwardRef as ReactComponent };